import { useMemo } from 'react';
import { MutationParameters, PayloadError, RecordSourceProxy } from 'relay-runtime';

import { AttachmentTypeInput } from '../graphql/__generated__/CreateAttachmentMutation.graphql';
import { UpdateBulkAttachmentOrderMutation$data } from '../graphql/__generated__/UpdateBulkAttachmentOrderMutation.graphql';

const useCommitAttachment = () => {
    const updateStore = (store: any, id: string, index: number) => {
        const oldAttachment = store.get(id);
        oldAttachment.setValue(index, 'order');
    };

    const getCommitBulkAttachment = useMemo(
        () =>
            (dataList: AttachmentTypeInput, connectionId: string): MutationParameters => {
                const optimisticUpdater = (store: RecordSourceProxy) => {
                    dataList.new_order?.forEach((id, index) => {
                        if (id) {
                            updateStore(store, id, index + 1);
                        }
                    });
                };

                return {
                    variables: {
                        input: dataList,
                        connections: [connectionId],
                    },
                    onCompleted: (response: UpdateBulkAttachmentOrderMutation$data, errors: PayloadError[]) => {
                        if (errors) {
                            console.log(
                                (
                                    errors[0] as PayloadError & {
                                        extensions: { debugMessage: string };
                                    }
                                ).extensions.debugMessage,
                                errors,
                            );
                        }
                    },
                    optimisticUpdater: optimisticUpdater,
                    onError: (error: any) => {
                        console.error('Mutation error:', error);
                    },
                } as any as MutationParameters;
            },
        [],
    );

    return { getCommitBulkAttachment };
};

export default useCommitAttachment;
